/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import * as React from 'react';
import { Footer } from '@scuf/common';
import { withRouter } from 'react-router-dom';
import Routes from '../common/routes';
import { withCustomerSiteContext } from '../common/HOCs';

class AppFooter extends React.Component {
  render() {
    return (
      <Footer>
        <Footer.Item href="https://www.honeywell.com/us/en/terms-and-conditions" target="_blank">
          Terms & Conditions
        </Footer.Item>
        <Footer.Item href="https://www.honeywell.com/us/en/privacy-statement" target="_blank">
          Privacy Policy
        </Footer.Item>
        <Footer.Item href="https://www.honeywellaidc.com/working-with-us/patents" target="_blank">
          Patents
        </Footer.Item>
        <Footer.Item href="https://www.honeywell.com/us/en/cookie-notice" target="_blank">
          Cookie Notice
        </Footer.Item>
        <Footer.Item href="https://hon-opcenter.my.salesforce-sites.com/PrivacyInformationRequestForm?lang=en" target="_blank">
          Your Privacy Choices<img src={window.location.origin + '/images/privacyoptions730x350.png'} width="35" height="18"/>
        </Footer.Item>
        <Footer.Item
          content="Third Party Licenses"
          onClick={() => {
            this.setState({ activeLink: Routes.ThirdPartyLicense });
            this.props.history.push(Routes.ThirdPartyLicense);
          }}
        />
        <Footer.Item content= {"Customer Name: " + this.props.custSiteContext.selectedCustomerName} />
      </Footer>
    );
  }
}

export default withRouter(withCustomerSiteContext(AppFooter));
